import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import InterestMaster from './interest-master';
import InterestMasterDetail from './interest-master-detail';
import InterestMasterUpdate from './interest-master-update';
import InterestMasterDeleteDialog from './interest-master-delete-dialog';

const InterestMasterRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<InterestMaster />} />
    <Route path="new" element={<InterestMasterUpdate />} />
    <Route path=":id">
      <Route index element={<InterestMasterDetail />} />
      <Route path="edit" element={<InterestMasterUpdate />} />
      <Route path="delete" element={<InterestMasterDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InterestMasterRoutes;
